import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Autoplay, Navigation, Pagination, Scrollbar, A11y } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import GenDuo from '../public/genduo'
import H2Title from '../public/h2Title'
import useMediaQuery from '../../hooks/useMediaQuery'
import { Col, Row } from 'antd'
import { BASE_URL } from '../../api/api'
import NavLink from '../navLink'

SwiperCore.use([Autoplay, Navigation, Pagination])

const Qyfc = ({ className, enterpriseList = {} }) => {
  const isMobile = useMediaQuery()
  const { list = [] } = enterpriseList || {}

  const paginate = page => {
    const startIndex = (page - 1) * 8
    const endIndex = startIndex + 8
    return list.slice(startIndex, endIndex)
  }

  const totalPage = Math.ceil(list.length / 8)

  return (
    <div className="w-full mt-[60px] px-5 lg:px-0">
      <div className="flex justify-center lg:justify-between items-center">
        <p className="hidden lg:block"></p>
        <H2Title title="企业风采" />
        <GenDuo
          href={`/qyfc/channel_id/${enterpriseList?.channel?.id}`}
          className="hidden lg:block"
        />
      </div>
      {isMobile ? (
        <div>
          <Row gutter={24}>
            {enterpriseList?.list?.map(({ image = '', id, outlink, title }, key) => {
              if (key > 7) return null
              return (
                <Col key={key} span={12}>
                  <NavLink
                    isOutLink={!!outlink}
                    className="mt-[30px]"
                    to={outlink || `/wzxq/id/${id}`}
                  >
                    <img className="mt-[30px]" src={`${BASE_URL}${image}`} alt="" />
                    <div className="w-full mt-2 overflow-hidden whitespace-nowrap truncate">
                      {title}
                    </div>
                  </NavLink>
                </Col>
              )
            })}
          </Row>
          <div className="flex lg:hidden justify-center">
            <GenDuo
              href={`/qyfc/channel_id/${enterpriseList?.channel?.id}`}
              className="mx-auto mt-[30px] bg-[#0189D5] px-6 py-2 rounded-xl text-white"
            />
          </div>
        </div>
      ) : (
        <Swiper
          className={`home-chart overflow-visible ${className}`}
          // modules={[Navigation, Pagination, Scrollbar, A11y]}
          spaceBetween={50}
          slidesPerView={1}
          navigation
          autoplay={{ delay: 3000 }}
        >
          {Array(totalPage)
            .fill('')
            .map((_, key) => (
              <SwiperSlide key={key} className="px-[47px]">
                <div className="flex justify-between flex-wrap">
                  {paginate(key + 1)?.map(({ image = '', id, outlink, title }, k) => (
                    <NavLink key={k} className="mt-[30px]" to={outlink || `/wzxq/id/${id}`}>
                      <img key={k} src={`${BASE_URL}${image}`} style={{ width: 260 }} alt="" />
                      <div className="w-[260px] mt-2 overflow-hidden whitespace-nowrap truncate">
                        {title}
                      </div>
                    </NavLink>
                  ))}
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      )}
    </div>
  )
}

export default Qyfc
